import { render, staticRenderFns } from "./scoretable.vue?vue&type=template&id=7db633ed&scoped=true"
import script from "./scoretable.vue?vue&type=script&lang=js"
export * from "./scoretable.vue?vue&type=script&lang=js"
import style0 from "./scoretable.vue?vue&type=style&index=0&id=7db633ed&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7db633ed",
  null
  
)

export default component.exports